import {
  UserSession,
  UserSessionStatus,
  WorkspaceContext,
} from '../types/authTypes';

import { useAppSelector } from '@store/hooks';

interface AuthSession {
  status: UserSessionStatus;
  user?: UserSession;
  workspaceContext?: WorkspaceContext;
  error?: string;
}

export function useAuthSession(): AuthSession {
  const { status, user, error } = useAppSelector((state) => state.auth);
  return {
    status,
    user,
    workspaceContext: user?.workspaceContext,
    error,
  };
}
